/* ============================================================
   QUELL — Home settings rail carousel.
   Turns the tile track into an arrow-driven carousel: prev/next
   buttons page the track, a progress thumb reflects position,
   buttons disable at each end, and controls hide when the track
   fits with no overflow. Swipe still works on touch. Respects
   prefers-reduced-motion and re-inits inside the Theme editor.
   Markup is server-rendered in sections/home-settings-rail.liquid.
   ============================================================ */
(function () {
  "use strict";
  if (window.__settingsRailCarousel) return;
  window.__settingsRailCarousel = true;

  var reduce =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function init(root) {
    if (!root || root.dataset.srInit === "1") return;
    var track = root.querySelector("[data-rail-track]");
    if (!track) return;
    var prev = root.querySelector("[data-rail-prev]");
    var next = root.querySelector("[data-rail-next]");
    var fill = root.querySelector("[data-rail-progress]");
    var ctrl = root.querySelector(".setrail-ctrl");
    root.dataset.srInit = "1";

    function maxScroll() {
      return track.scrollWidth - track.clientWidth;
    }

    function update() {
      var max = maxScroll();
      if (max <= 2) {
        if (ctrl) ctrl.setAttribute("hidden", "");
        return;
      }
      if (ctrl) ctrl.removeAttribute("hidden");
      var x = track.scrollLeft;
      var pct = x / max; // 0 → 1
      if (fill) {
        var segPct = Math.max(14, (track.clientWidth / track.scrollWidth) * 100);
        fill.style.width = segPct + "%";
        fill.style.marginLeft = pct * (100 - segPct) + "%";
      }
      if (prev) prev.disabled = x <= 1;
      if (next) next.disabled = x >= max - 1;
    }

    function page(dir) {
      track.scrollBy({
        left: dir * track.clientWidth * 0.85,
        behavior: reduce ? "auto" : "smooth",
      });
    }

    if (prev) prev.addEventListener("click", function () { page(-1); });
    if (next) next.addEventListener("click", function () { page(1); });
    track.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);

    update();
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll("[data-rail-carousel]")
      .forEach(init);
  }

  function ready(fn) {
    if (document.readyState === "loading")
      document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  ready(function () {
    initAll(document);
  });

  document.addEventListener("shopify:section:load", function (e) {
    initAll(e.target);
  });
  document.addEventListener("shopify:section:select", function (e) {
    initAll(e.target);
  });
})();
